// extracted by mini-css-extract-plugin
export default {"alertContainer":"SuccessAlert_alertContainer__1ig8d","alert":"SuccessAlert_alert__StVbV","icon":"SuccessAlert_icon__CtcCO","dismissButton":"SuccessAlert_dismissButton__VpbFP"};